/// <amd-module name="Test/TestPlansHubRefresh/TestCaseWorkItemControls/TestSteps/Constants" />
export const TestStepsFieldName = "Microsoft.VSTS.TCM.Steps";
